import { html, ifDefined } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../config.js';
import { customerDataManager, infrastructure, moduleLoader } from '../infrastructure.js';

/**
 * @param {UrlSearchParams} query - object representing query parameters
 * @returns {TemplateResult}
 */
export default function renderProductsAndServicesEligibleListPageTemplate({ query, anchor }) {
  moduleLoader.loadModule(config.margaretWidgetUrl);

  return html`
    <div class="section bg-gray vertical-stretch">
      <div class="container">
        <osk-products-and-services-eligible-list
          .infrastructure=${infrastructure}
          .query=${query}
          anchor=${ifDefined(anchor)}
          working-sn=${customerDataManager.workingSn}
        ></osk-products-and-services-eligible-list>
      </div>
    </div>
  `;
}
